var _excluded = ["Component", "href", "to", "external", "children"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

var isValidUrl = function isValidUrl() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  try {
    new URL(string); // eslint-disable-line no-new

    return true;
  } catch (err) {
    return false;
  }
};
/**
 * Link Component to handle app navigation.
 * If a Component is passed as prop this will handle the Link navigation else a <a> tag will be used
 */


var BaseLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var Component = _ref.Component,
      href = _ref.href,
      to = _ref.to,
      _ref$external = _ref.external,
      external = _ref$external === void 0 ? false : _ref$external,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var renderLinkComponent = typeof Component !== 'undefined';
  var isInternal = external === false;
  var isUrl = isValidUrl(href || to);

  if (renderLinkComponent && isInternal && !isUrl) {
    // Change this logic when no SPA is using react-router-dom Link component
    // Handle different link url props for link component
    var hrefProp = href ? {
      href: href
    } : {};
    var toProp = to ? {
      to: to
    } : {};
    return /*#__PURE__*/React.createElement(Component, _extends({
      ref: ref
    }, hrefProp, toProp, otherProps), children);
  }

  return (
    /*#__PURE__*/
    // Ignoring rule, false positive
    // eslint-disable-next-line react/jsx-no-target-blank
    React.createElement("a", _extends({
      ref: ref // when no SPA is using react-router-dom Link component no need to pass down to
      ,
      href: href || to,
      rel: external ? 'noopener noreferrer nofollow' : null,
      target: external ? '_blank' : null
    }, otherProps), children)
  );
});
BaseLink.displayName = 'BaseLink';
BaseLink.propTypes = process.env.NODE_ENV !== "production" ? {
  Component: PropTypes.elementType,

  /**
   * Destination of the Link
   */
  href: PropTypes.string,

  /**
   * Destination of the Link
   */
  to: PropTypes.string,

  /**
   * Is the link going outside of the current app
   */
  external: PropTypes.bool,
  children: PropTypes.node
} : {};
export default BaseLink;
//# sourceMappingURL=BaseLink.js.map